import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import { AzarAlternativeBanner } from "./Banners";
import FAQSection from "../../components/FAQSection";
import "./landing.css";

export default function AzarAlternative() {
  return (
    <>
      <SEO
        title="Best Azar Alternative - Talkvee (No App Needed & Free)"
        description="Looking for a free Azar alternative? Talkvee works instantly in your browser. No app downloads, no paid gems, just free random video chat and games."
        pathname="/azar-alternative"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://talkvee.com" },
            { "@type": "ListItem", "position": 2, "name": "Azar Alternative", "item": "https://talkvee.com/azar-alternative" }
          ]
        }}
      />

      <div className="landing-wrapper">
        <AzarAlternativeBanner />
        
        <section className="landing-hero">
          <h1 className="landing-title">The Browser-Based Azar Alternative</h1>
          <p className="landing-subtitle">
            Skip the heavy app downloads and the expensive "gem" systems. Talkvee connects you instantly right in your mobile or desktop browser. Enjoy 100% free video chat with real people and built-in icebreaker games.
          </p>
          <Link to="/" className="tv-cta">🚀 Start Chatting on Talkvee</Link>
        </section>

        <section className="comparison-section" style={{maxWidth: '800px', margin: '40px auto', padding: '0 15px'}}>
          <h3 style={{textAlign: 'center', marginBottom: '20px', color: 'var(--tv-text)'}}>Talkvee vs. Azar</h3>
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', textAlign: 'left'}}>
            <div style={{background: '#fee2e2', padding: '20px', borderRadius: '12px', border: '1px solid #fecaca'}}>
              <h4 style={{margin: '0 0 10px', color: '#b91c1c', fontSize: '1.1rem'}}>❌ Azar</h4>
              <ul style={{paddingLeft: '20px', margin: 0, color: '#7f1d1d', lineHeight: '1.6'}}>
                <li>Requires App Download</li>
                <li>Expensive "Gems" System</li>
                <li>Paid Region Filters</li>
              </ul>
            </div>
            <div style={{background: '#dcfce7', padding: '20px', borderRadius: '12px', border: '1px solid #bbf7d0'}}>
              <h4 style={{margin: '0 0 10px', color: '#15803d', fontSize: '1.1rem'}}>✅ Talkvee</h4>
              <ul style={{paddingLeft: '20px', margin: 0, color: '#14532d', lineHeight: '1.6'}}>
                <li>Instant Browser Access</li>
                <li>100% Free Forever</li>
                <li>Interactive Chat Games</li>
              </ul>
            </div>
          </div>
        </section>

        <FAQSection
          items={[
            {
              q: "Do I need to download an app to use Talkvee?",
              a: "No! Unlike Azar, Talkvee is a Progressive Web App (PWA) that runs lightning-fast directly in your Chrome or Safari mobile browser."
            },
            {
              q: "Does Talkvee use a coin or gem system?",
              a: "Absolutely not. Talkvee is 100% free. We don't charge you gems to match with people or use our core features."
            },
            {
              q: "Is Talkvee safe?",
              a: "Yes, we use strict moderation and reporting systems to ensure the platform remains a safe and fun place to meet strangers."
            }
          ]}
        />
      </div>
    </>
  );
}